import React from 'react'
import Dialog from '@mui/material/Dialog'

import { Avatar, Button } from '../../../../components/UI'

import { getUserName } from '../../../../helpers'

import { imagePrefix } from '../../../../constants'

const BookTutorSuccessModal = ({ open, classBanner, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper:
          'relative md:!max-w-[648px] !p-[32px] !rounded-[12px] !bg-[#FEEBDD] !shadow-modal-light',
      }}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <img src="/assets/image/booking-success.svg" alt="Success" width={124} height={124} />

        <h2 className="text-[20px] font-bold leading-[32px] text-primary-100 mt-[16px]">
          Booking Successful
        </h2>

        <p className="mt-[8px] w-full text-center text-sm font-medium text-primary-100">
          You have successfully booked a class.
          <br />
          We will let you know once the tutor takes an action (accepts/declines) on your booking.
        </p>

        {classBanner && (
          <div className="px-[22px] w-full mt-[24px]">
            <div className="w-full p-[24px] bg-[#FFF5EE] rounded-[10px] shadow-modal-light border-[#FFCA84] border-[1px] flex flex-col items-start gap-y-[10px]">
              <h3 className="text-base font-bold text-primary-100">Booking Details</h3>

              <div className="w-full flex items-center justify-between">
                <span className="text-base text-primary-100">Class</span>

                <span className="text-base text-primary-100">
                  {classBanner.class_banner_category.name}
                </span>
              </div>

              <div className="w-full flex items-end justify-between">
                <span className="text-base text-primary-100">Schedule</span>

                {/* TODO */}
                <span className="text-base text-primary-100">Tuesday, May 22 - 10:00 AM</span>
              </div>

              <div className="w-full flex items-end justify-between">
                <span className="text-base text-primary-100">Tutor</span>

                <div className="flex items-center">
                  <Avatar
                    src={
                      classBanner.class_banner_creator.profile_picture
                        ? `${imagePrefix}${classBanner.class_banner_creator.profile_picture}`
                        : ''
                    }
                    gender={classBanner.class_banner_creator.gender}
                    className="w-[24px] h-[24px] mr-[10px]"
                  />

                  <span className="text-base font-semibold text-primary-100 max-w-[200px] text-ellipsis whitespace-nowrap overflow-hidden">
                    {getUserName(
                      classBanner.class_banner_creator,
                      classBanner.creator_profile?.display_name,
                      classBanner.creator_profile?.display_last_name
                    )}
                  </span>
                </div>
              </div>

              <div className="w-full flex items-end justify-between">
                <span className="text-base text-primary-100">Status</span>

                {/* TODO */}
                <span className="text-base text-white font-bold h-[32px] px-[8px] rounded-[8px] bg-[#338AF3] flex items-center justify-center">
                  In Review
                </span>
              </div>
            </div>
          </div>
        )}

        <Button type="button" onClick={onClose} className="w-full mt-[24px] text-lg">
          Continue
        </Button>
      </div>
    </Dialog>
  )
}

export default BookTutorSuccessModal
